var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"up"},[_c('img',{attrs:{"src":require("@/assets/images/home/footer_icon.png"),"alt":""}}),_c('div',{staticClass:"text"},[_c('p',[_vm._v("服务热线: 15382305057")])])]),_c('div',{staticClass:"down"},[_vm._v("Copyright © 杭州辰有智能科技有限公司 版权所有 浙ICP备2023033855号-2")])])
}]

export { render, staticRenderFns }